import { OdpMonitoringReason, OdpMonitoringResult, OdpMonitoringStage } from 'api';
import { FilterOption } from '@britishcouncil/react-admin';
import {
  getOdpMonitoringReasonName,
  getOdpMonitoringResultName,
  getOdpMonitoringStageName,
} from './odpMonitoringHelpers';

export const ODP_MONITORING_REASON_OPTIONS: FilterOption<OdpMonitoringReason>[] = Object.values(
  OdpMonitoringReason
)
  .filter((value) => typeof value === 'number')
  .map((value) => ({
    text: getOdpMonitoringReasonName(value as OdpMonitoringReason),
    value: value as OdpMonitoringReason,
  }));

export const ODP_MONITORING_RESULT_OPTIONS: FilterOption<OdpMonitoringResult>[] = Object.values(
  OdpMonitoringResult
)
  .filter((value) => typeof value === 'number')
  .map((value) => ({
    text: getOdpMonitoringResultName(value as OdpMonitoringResult),
    value: value as OdpMonitoringResult,
  }));

export const ODP_MONITORING_STAGE_OPTIONS: FilterOption<OdpMonitoringStage>[] = Object.values(
  OdpMonitoringStage
)
  .filter((value) => typeof value === 'number')
  .map((value) => ({
    text: getOdpMonitoringStageName(value as OdpMonitoringStage),
    value: value as OdpMonitoringStage,
  }));

export const VALID_ODP_MONITORING_REASONS = ODP_MONITORING_REASON_OPTIONS.map(
  (option) => option.value
);

export const VALID_ODP_MONITORING_RESULTS = ODP_MONITORING_RESULT_OPTIONS.map(
  (option) => option.value
);

export const VALID_ODP_MONITORING_STAGES = ODP_MONITORING_STAGE_OPTIONS.map(
  (option) => option.value
);
